import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

const JumbotronSearchBanner = ({
  button,
  searchSuggestions,
  jumbotronType,
  backgroundBigText,
  jumbotronContainerClassName,
  jumbotronEntityInfoClassName,
}) => {
  let searchSuggestionsbutton;
  if (searchSuggestions === null) {
    searchSuggestionsbutton = false;
  } else if (searchSuggestions.length < 1) {
    searchSuggestionsbutton = false;
  } else {
    searchSuggestionsbutton = true;
  }

  return (
    <div className={cs(jumbotronContainerClassName, jumbotronType)}>
      {backgroundBigText}
      <div className={cs('JumbotronBanner__wrapper', jumbotronType)}>
        {/* Header Entity Info Section */}
        <div className={`${jumbotronEntityInfoClassName}__container`}>
          <div className={jumbotronEntityInfoClassName}>
            {/*  TODO: Add translations for top result */}
            {searchSuggestionsbutton === true && <div className="Jumbotron__topResult">Top matches:</div>}
            <div className="Jumbotron__topResult_data">{button}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

JumbotronSearchBanner.propTypes = {
  jumbotronType: PropTypes.string.isRequired,
  backgroundBigText: PropTypes.object,
  jumbotronContainerClassName: PropTypes.string.isRequired,
  button: PropTypes.node,
  searchSuggestions: PropTypes.array,
  jumbotronEntityInfoClassName: PropTypes.string.isRequired,
};

export default JumbotronSearchBanner;
